import courseOne from '#/assets/courses/course-1.png'
import courseTwo from '#/assets/courses/course-2.png'
import courseThree from '#/assets/courses/course-3.webp'

export const COURSES_CONTENT = {
  eyebrow: 'Popular Courses',
  title: 'Our Islamic & Arabic Courses',
  cardTitle: 'Online Tajweed Rules Course',
  cardDescription:
    'Comprehensive Islamic courses covering Aqeedah, Fiqh, Seerah, and essential knowledge for daily Muslim life.',
  buttonLabel: 'Sea More',
}

export const COURSES = [
  {
    image: courseOne,
    tag: 'Quran',
  },
  {
    image: courseTwo,
    tag: 'Arabic',
  },
  {
    image: courseThree,
    tag: 'Tajweed',
  },
]
